var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spin-tracker circular-element"},[_c('div',{staticClass:"spins"},[_vm._v(_vm._s(_vm.spins))]),_c('div',{staticClass:"title"},[_vm._v("Spins")])])}
var staticRenderFns = []

export { render, staticRenderFns }